import React from 'react'
import { connect } from 'react-redux'
import { mapStateToProps } from '../container'
import './name.css'

const careType = ({ type }) => (String(type).toLowerCase() === 'service' ? 'Service' : 'Provider')

const DisplayRegHolderName = ({ current_reg_holder }) => (
  <div className="currentService--wrapper">
    <div className="currentService--type">{careType(current_reg_holder)}</div>
    {current_reg_holder.name || 'Loading...'}
  </div>
)

export default connect(mapStateToProps)(DisplayRegHolderName)



// WEBPACK FOOTER //
// ./src/layout/authorised-layout/current-reg-holder/name/index.jsx